import { Component } from 'react';
import {Col, Row} from 'react-bootstrap';
import {dateFormatUK} from '../../../utils/commonFunctions';
import Can from '../../common/guards/can';
import t from '../../../data/translations';

class TeamRewardDetails extends Component {
  render() {
    const {store} = this.props;
    return (
      <Row>
        <Col lg={6}>
          <Row>
            <Col lg={6}>
              <p>
                Outlet points earned:
              </p>
            </Col>
            <Col lg={6}>
              <p>
                {store.attributes['outlet-points']}
              </p>
            </Col>
          </Row>
          <Can subjectClass="level_rep_area" action="view">
            <Row>
              <Col lg={6}>
                <p>
                  Outlet level:
                </p>
              </Col>
              <Col lg={6}>
                <p>
                  {store.attributes.level}
                </p>
              </Col>
            </Row>
          </Can>
        </Col>
        <Col lg={6}>
          <Can subjectClass="rewards_details_personal_rewards" action="show">
            <Row>
              <Col lg={12}>
                <p>
                  <strong>
                    Personal Rewards
                  </strong>
                </p>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <p>
                  Date of opt in:
                </p>
              </Col>
              <Col lg={6}>
                <p>
                  {dateFormatUK(store.attributes['date-of-opt-in'])}
                </p>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <p>
                  Next load amount:
                </p>
              </Col>
              <Col lg={6}>
                <p>
                  {t('currency')}
                  {store.attributes['next-load-amount']}
                </p>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <p>
                  Next load date:
                </p>
              </Col>
              <Col lg={6}>
                <p>
                  {dateFormatUK(store.attributes['next-load-date'])}
                </p>
              </Col>
            </Row>
          </Can>
        </Col>
      </Row>
    );
  }
}

export default TeamRewardDetails;
